import { createPendingQueueStore } from '../lib/pendingQueue.js';

/**
 * Offline buffer for finished exam tasks. QUEUE-FIRST: a finished task
 * is enqueued before the RPC attempt and removed on success, so closing the
 * app mid-flight never loses it. `complete_exam_task` is idempotent per
 * (attempt, task), so a double-send (direct call + flusher racing) is
 * harmless.
 */

export interface PendingExamTask {
  /** `${attempt_id}:${task}` */
  id: string;
  attempt_id: string;
  test: number;
  task: number;
  correct: number;
  userId: string;
  queuedAt: number;
  attempts?: number;
  lastAttemptAt?: number;
}

export const usePendingExamTaskStore = createPendingQueueStore<{
  tasks: PendingExamTask;
}>({
  storageKey: 'fluent.pending-exam-tasks.v1',
  collections: { tasks: (t) => t.id },
});
